module.exports = __webpack_public_path__ + "static/media/banner_ecomerce_cremacion_1920_.9862c982.jpg";